import { type RadioGroupOption, type OptionProps } from '@amelio/ui-library';

import { ScheduleCompletion } from './components/ScheduleCompletion/ScheduleCompletion';
import { ScheduleFrequency } from './components/ScheduleFrequency/ScheduleFrequency';

import type { ReviewScheduleType } from '@/constants/review/ReviewScheduleType';

interface SchedulingOptionsProps {
    options?: RadioGroupOption[];
    frequencyOptions?: OptionProps[];
    schedulingOption?: ReviewScheduleType;
    daysToComplete?: number;
    scheduleFrequency?: boolean;
    scheduledAt: Date;
    feedbackFrequency?: string;
    onSchedulingOptionChange?: (value: string) => void;
    onDaysToCompleteChange?: (value: number) => void;
    onScheduledAtChange: (date: Date) => void;
    onFeedbackFrequencyChange?: (value: string) => void;
    hasSelfAssessment?: boolean;
}

const SchedulingOptions = ({
    options,
    frequencyOptions,
    schedulingOption,
    daysToComplete,
    scheduleFrequency = false,
    scheduledAt,
    feedbackFrequency,
    onSchedulingOptionChange,
    onDaysToCompleteChange,
    onScheduledAtChange,
    onFeedbackFrequencyChange,
    hasSelfAssessment = false,
}: SchedulingOptionsProps) => {
    if (scheduleFrequency) {
        return (
            <ScheduleFrequency
                options={frequencyOptions}
                scheduledAt={scheduledAt}
                feedbackFrequency={feedbackFrequency}
                onScheduledAtChange={onScheduledAtChange}
                onFeedbackFrequencyChange={onFeedbackFrequencyChange}
            />
        );
    }

    return (
        <ScheduleCompletion
            options={options}
            schedulingOption={schedulingOption}
            daysToComplete={daysToComplete}
            scheduledAt={scheduledAt}
            onSchedulingOptionChange={onSchedulingOptionChange}
            onDaysToCompleteChange={onDaysToCompleteChange}
            onScheduledAtChange={onScheduledAtChange}
            hasSelfAssessment={hasSelfAssessment}
        />
    );
};

export { SchedulingOptions };
export type { SchedulingOptionsProps };
